import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { BaseComponent } from '../../base/base.component';
import { WizardService } from '../../../services/wizard/wizard.service';
import { IWizardOptions } from '../../../models';

@Component({
    selector: 'wizard-max-attendees',
    templateUrl: './max-attendees.component.html',
    styleUrls: ['./max-attendees.component.scss', '../../form-styles.scss']
})
export class MaxAttendeesComponent extends BaseComponent implements OnInit {
    public maxAttendees: number;
    private defaultsSubscription: Subscription;

    constructor(public wizardService: WizardService) {
        super();
    }

    ngOnInit() {
        this.subscribeToMeetingDefaultsUpdates();
    }

    ngOnDestroy() {
        this.defaultsSubscription.unsubscribe();
    }

    subscribeToMeetingDefaultsUpdates() {
        this.defaultsSubscription = this.wizardService.onNewDefaultOptions$.subscribe((defaults: IWizardOptions) => {
            if (defaults) {
                this.updateMaxAttendees(defaults.maxAttendees);
            }
        });
    }

    handleToggleMaxAttendees(maxAttendeesToggle: boolean) {
        this.maxAttendees = maxAttendeesToggle ? this.maxAttendees || 25 : undefined;
        this.updateMaxAttendees(this.maxAttendees);
    }

    updateMaxAttendees(maxAttendees?: number) {
        this.maxAttendees = maxAttendees;
        if (maxAttendees) {
            this.wizardService.updateOptions({
                maxAttendees
            });
        } else {
            this.wizardService.updateOptions({ maxAttendees: undefined });
        }
    }
}
